// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"31":"lazy-chunk.c5t","599":"lazy-chunk.s8e"}[chunkId] + "." + {"31":"55847e0b","599":"13db0924"}[chunkId] + ".chunk.css";
};